export default {
  CPQ: {
    "button.createQuote": "Create quote",
    "dialog.confirm.genericDelete.subtitle":
      "Tem certeza de que deseja excluir este item?",
    "opportunity.title": "Oportunidade",
    "opportunity.heading": "Oportunidade {{name}} {{id}}",
    "cart.title": "Carrinho",
    "button.addQuote": "Adicionar cotação",
    "button.addLineItem": "Novo item",
    "dialog.addLineItem.title": "Novo item",
    "button.presets": "Predefinições",
    "button.upload": "Carregar",
    "button.archive": "Arquivar",
    "button.createOpportunity": "Criar oportunidade",
    "button.cancel": "Cancelar",
    "button.save": "Ok",
    "button.reset": "Reiniciar",
    "button.confirm": "Ok",
    "button.goToCatalog": "Ir para o catálogo",
    "button.inventoryDocumentation": "Inventário de documentação",
    "button.download": "Download",
    "button.start": "Iniciar",
    "button.logout": "Logout",
    "button.addCustomProduct": "Produto customizado",
    "button.addProduct": "Produto",
    "button.addFilter": "Adicionar filtro",
    "button.delete": "Deletar",
    "select.language": "Idioma",
    "dialog.createOpportunity.subtitle": "Criar uma nova oportunidade",
    "dialog.updateOpportunity.title": "Editar oportunidade",
    "dialog.updateOpportunity.subtitle": "Editar uma oportunidade existente",
    "button.footer.backToOverview": "Voltar para o resumo",
    "button.footer.saveAndExit": "Salvar e sair",
    "footer.status.title": "Status",
    "button.footer.setStatusManually": "Set status manually",
    "button.footer.generateDocument": "Gerar documentação",
    "button.preview": "Preview",
    "button.footer.backToConfiguration": "Voltar à configuração",
    "button.addConfigurableProduct": "Adicionar produto configurado",
    "buttons.addConfigurationToItemGroupsButtonSelect.label":
      "Adicionar à cotação",
    "button.unarchiveOpportunity": "Restaurar",
    "button.archiveOpportunity": "Arquivar",
    "button.addItemGroup": "Novo grupo",
    "button.updateItemGroup": "Editar",
    "dialog.createCustomer.title": "Create customer",
    "dialog.createCustomer.subtitle": "Create a new customer",
    "dialog.createCompany.title": "Create company",
    "dialog.createCompany.subtitle": "Create a new company",
    "dialog.addLineItem.input.label.lineItemName": "Line item name",
    "dialog.createOpportunity.input.label.opportunityName": "Nome",
    "dialog.createOpportunity.input.label.customer": "Cliente",
    "dialog.createOpportunity.input.label.zipCode": "CEP",
    "dialog.createOpportunity.input.label.city": "Cidade",
    "dialog.createOpportunity.input.label.description": "Descrição",
    "dialog.createOpportunity.title": "Nova oportunidade",
    "dialog.createOpportunity.input.validFrom.label": "Válido de",
    "dialog.createOpportunity.input.validTo.label": "Válido até",
    "dialog.configuratorMode.title": "Criar nova cotação",
    "dialog.configuratorMode.option.configurator.title": "Configuração",
    "dialog.configuratorMode.option.configurator.description":
      "Configuração geral do sistema",
    "dialog.configuratorMode.option.expressMode.title": "Express Mode",
    "dialog.configuratorMode.option.expressMode.description":
      "Single item order",
    "dialog.configuratorMode.description": "Choose your preferred mode",
    "dialog.confirm.unarchiveQuote.title": "Restore quote",
    "dialog.confirm.unarchiveQuote.description":
      "Do you really want to restore this quote?",
    "dialog.confirm.archiveQuote.title": "Archive quote",
    "dialog.confirm.archiveQuote.description":
      "Do you really want to archive this quote?",
    "dialog.confirm.unarchiveOpportunity.title": "Restore opportunity",
    "dialog.confirm.unarchiveOpportunity.description":
      "Do you really want to restore this opportunity?",
    "dialog.confirm.archiveOpportunity.title": "Archive opportunity",
    "dialog.confirm.archiveOpportunity.description":
      "Do you really want to archive this opportunity?",
    "dialog.confirm.setOptional.title": "Set optional",
    "dialog.confirm.unsetOptional.title": "Unset optional",
    "dialog.confirm.setOptional.subtitle":
      "Do you really want to set this item as optional?",
    "dialog.confirm.unsetOptional.subtitle":
      "Do you really want to unset this item as optional?",
    "dialog.confirm.genericDelete.title": "Excluir",
    "dialog.addProducts.title.addProduct": "Selecionar produtos",
    "dialog.addItemGroup.title": "New group",
    "dialog.addItemGroup.input.label.itemGroupName": "Group name",
    "dialog.updateItemGroup.title": "Edit group",
    "dialog.updateItemGroup.input.label.itemGroupName": "Group name",
    "dialog.updateLineItem.title": "Edit line item",
    "dialog.updateLineItem.input.label.itemGroupName": "Line item name",
    "dialog.updateDefault.title": "Editar",
    "dialog.updateDefault.input.label.name": "Nome",
    "dialog.addCustomProduct.title": "Add custom product",
    "dialog.addCustomProduct.identifier": "Identifier",
    "dialog.addCustomProduct.partId": "Article number",
    "dialog.addCustomProduct.name": "Name",
    "dialog.addCustomProduct.description": "Description",
    "dialog.addCustomProduct.customer": "Customer",
    "dialog.addCustomProduct.productTypeId": "Descrição do produto",
    "dialog.addCustomProduct.productStateId": "Product State",
    "dialog.addCustomProduct.isShared": "Shared product",
    "dialog.addCustomProduct.isActive": "Active",
    "breadcrumb.opportunities": "Opportunities",
    "breadcrumb.quotes": "Quotes",
    "breadcrumb.itemGroups": "Item Groups",
    "breadcrumb.archive": "Archive",
    "breadcrumb.configurator": "Configurator",
    "breadcrumb.expressMode": "Express mode",
    "breadcrumb.lineItems": "Line item",
    "breadcrumb.overview": "Overview",
    "breadcrumb.catalog": "Catalog",
    "breadcrumb.salesQuotationView": "Sales quotation view",
    "breadcrumb.summaryView": "Summary view",
    "breadcrumb.ManagementView": "Management view",
    "breadcrumb.quoteInfo": "Quote info",
    "breadcrumb.texts": "Texts",
    "breadcrumb.documentGeneration": "Geração de documentos",
    "header.opportunity": "Opportunity",
    "header.opportunities": "Opportunities",
    "header.quoteDetails": "Quote",
    "header.itemGroupDetails": "Item Group",
    "header.archive": "Archive",
    "header.configurator": "Configurador",
    "header.expressMode": "Express mode",
    "header.lineItemDetails": "Line item",
    "header.presets": "Presets",
    "dropZone.label": "Drag & drop or browse",
    "dropZone.isDragActive.label": "Drop here",
    "fileUpload.label": "Stock images",
    "filters.input.label.identifier": "Nome",
    "filters.input.label.zipCode": "CEP",
    "filters.input.label.city": "Cidade",
    "filters.input.label.customer": "Cliente",
    "filters.input.label.status": "Status",
    "filters.input.label.search": "Procurar",
    "quote.property.label.uniqueNumberString": "Quote number",
    "quote.property.label.name": "Nome",
    "quote.property.label.description": "Descrição",
    "quote.property.label.region": "Estado",
    "quote.property.label.revision": "Número de revisão",
    "quote.property.label.createdBy": "Criado por",
    "quote.property.label.customer": "Cliente",
    "quote.property.label.lastUpdatedOn": "Última atualização em",
    "quote.property.label.lastUpdatedBy": "Atualizado por",
    "quote.property.label.status": "Status",
    "accordion.itemGroup.title": "Group",
    "itemGroup.name": "Group Name",
    "table.actions.deleteRow": "Excluir",
    "table.lineItems.header.articleNumber": "Item",
    "table.lineItems.header.partId": "GPS ID",
    "table.lineItems.header.name": "Nome",
    "table.lineItems.header.identifier": "ID",
    "table.lineItems.header.productIdentifier": "ID do produto",
    "table.lineItems.header.description": "Descrição",
    "table.lineItems.header.quantity": "Quantidade",
    "table.lineItems.header.actions": "Ações",
    "table.lineItems.header.optional": "Opcional",
    "table.lineItems.header.company": "Empresa",
    "table.lineItems.actions.cloneRow": "Clonar",
    "table.lineItems.actions.deleteRow": "Excluir",
    "table.lineItems.actions.showBOM": "Show BOM",
    "table.lineItems.actions.showSummary": "Show Summary",
    "catalog.productTable.header.favorit": "Favorit",
    "catalog.productTable.header.preview": "Preview",
    "catalog.productTable.header.articleNumber": "Article number",
    "catalog.productTable.header.name": "Name",
    "catalog.productTable.header.description": "Description",
    "catalog.productTable.header.cost": "cost",
    "catalog.productTable.header.totalCost": "Total cost",
    "catalog.productTable.header.listPrice": "List price",
    "catalog.productTable.header.actions": "Quantity",
    "catalog.productTable.header.createdByName": "Created by",
    "catalog.productTable.header.createdOn": "Created On",
    "catalog.productTable.header.lastUpdatedOn": "Last updated on",
    "catalog.productTable.header.lastUpdatedByName": "Last updated by",
    "catalog.productTable.buttons.addProductToGroup": "Add",
    "catalog.productTable.buttons.addAllProductsToGroup": "Add all",
    "catalog.productTable.menu.addLineItemToNewGroup": "Create new group",
    "catalog.buttons.showLineItems": "Show line items",
    "catalog.buttons.columnsSelection": "Columns",
    "buttons.toggleSideView.label": "Sideview",
    "product.types.tooltip.Configurable": "Configurable",
    "product.types.tooltip.NonConfigurable": "Non configurable",
    "product.types.tooltip.PreConfigured": "Preconfigured",
    "product.types.tooltip.configurationStatus.toConfigure": "To be configured",
    "product.types.tooltip.configurationStatus.complete":
      "Configuration is complete",
    "product.types.tooltip.configurationStatus.incomplete":
      "Configuration is incomplete",
    "product.status.text.toConfigure": "Configure",
    "product.status.text.complete": "Configured",
    "product.status.text.incomplete": "Edit",
    "productsTable.tree.filter": "Filter",
    "productsTable.tree.categoriesToggleText": "Categories",
    "relatedProducts.title": "Related products",
    "relatedProducts.noProducts": "No products",
    "alternativeProducts.title": "Alternative products",
    "table.itemGroups.title": "Project",
    "table.itemGroups.header.rank": "Rank",
    "table.itemGroups.header.moveRow": "Move row",
    "table.itemGroups.header.name": "Name",
    "table.itemGroups.header.description": "Description",
    "table.itemGroups.header.partId": "Part ID",
    "table.itemGroups.header.managingEntity": "Managing entity (ME)",
    "table.itemGroups.header.priceList": "Price list",
    "table.itemGroups.header.supportingEntity": "Supporting entity (SE)",
    "table.itemGroups.header.qty": "Quantity",
    "table.itemGroups.header.itemCost": "Item cost",
    "table.itemGroups.header.costListPricing": "Cost+/List-pricing",
    "table.itemGroups.header.markup": "Markup",
    "table.itemGroups.header.markupPercentage": "Cost Markup (%)",
    "table.itemGroups.header.itemList": "Item list",
    "table.itemGroups.header.totalList": "Total List",
    "table.itemGroups.header.discount": "Discount",
    "table.itemGroups.header.discount2": "Discount 2",
    "table.itemGroups.header.discount3": "Discount 3",
    "table.itemGroups.header.discount4": "Discount 4",
    "table.itemGroups.header.totalDiscount": "Total discount",
    "table.itemGroups.input.label.markup": "Markup",
    "table.itemGroups.input.label.discount": "Discount",
    "table.itemGroups.input.label.discount2": "Discount 2",
    "table.itemGroups.input.label.discount3": "Discount 3",
    "table.itemGroups.input.label.discount4": "Discount 4",
    "table.itemGroups.input.label.markupPercentage": "Cost Markup (%)",
    "table.itemGroups.input.label.discountPercentage": "Discount (%)",
    "table.itemGroups.input.label.discount2Percentage": "Discount 2 (%)",
    "table.itemGroups.input.label.discount3Percentage": "Discount 3 (%)",
    "table.itemGroups.input.label.discount4Percentage": "Discount 4 (%)",
    "table.itemGroups.input.label.serviceDiscountPercentage": "Discount 2 (%)",
    "table.itemGroups.input.label.bonusDiscountPercentage": "Discount 3 (%)",
    "table.itemGroups.input.label.projectDiscountPercentage": "Discount 4 (%)",
    "table.itemGroups.header.discountPercentage": "Discount (%)",
    "table.itemGroups.header.discount2Percentage": "Discount 2 (%)",
    "table.itemGroups.header.discount3Percentage": "Discount 3 (%)",
    "table.itemGroups.header.discount4Percentage": "Discount 4 (%)",
    "table.itemGroups.header.totalDiscountPercentage": "Total discount (%)",
    "table.itemGroups.header.totalNet": "Total Net",
    "table.itemGroups.header.margin": "Gross Margin",
    "table.itemGroups.header.cost": "Cost",
    "table.itemGroups.header.actions": "Actions",
    "table.itemGroups.header.totalCost": "Total cost",
    "table.itemGroups.header.listPrice": "List price",
    "table.itemGroupsOptional.title": "Optional",
    "categories.sharedProducts": "Shared products",
    "categories.customProducts": "Custom products",
    "catalog.productTable.buttons.addProductToLineItem": "Add to Line Item",
    "catalog.productTable.buttons.addAllProductsToLineItem":
      "Add all to Line Item",
    "catalog.productTable.buttons.addProductsToQuote": "Add to Quote",
    "catalog.productTable.buttons.addAllProductsToQuote": "Add all to Quote",
    "quote.buttons.exportToExcel": "Export",
    "catalog.selectACategoryFirst": "Select a category first",
    "button.import": "Import",
    "dialog.importExcel.title": "Import Excel",
    "dialog.createQuote.title": "Create quote",
    "dialog.createQuote.subtitle": "Create a new quote",
    "dialog.createQuote.input.label.name": "Name",
    "dialog.createQuote.input.label.description": "Description",
    "dialog.createQuote.input.label.region": "Region",
    "dialog.createQuote.input.label.customer": "Customer",
    "dialog.updateQuote.title": "Edit quote",
    "dialog.updateQuote.subtitle": "Adjust an existing quote",
    "button.uploadGeneric.placeholder": "Upload file",
    "checkbox.import.label.override": "Check here to override existing entries",
    priceListSelectLabel: "Price list",
    currencySelectLabel: "Currency",
    "button.goBackToOpportunities": "Back to opportunities",
    "button.goBackToOpportunity": "Back to opportunity",
    "button.goBackToQuote": "Back to quote",
    "item.property.label.note": "Customer position / asset position",
    "item.property.label.listPrice": "List price",
    "item.property.label.totalList": "Total list price",
    "item.property.label.discount": "Discount",
    "item.property.label.totalDiscount": "Total discount",
    "item.property.label.totalCost": "Total cost",
    "item.property.label.totalNet": "Total net price",
    "item.property.label.status": "Status",
    "item.property.label.name": "Name",
    "item.property.label.partId": "Article number",
    "item.property.label.description": "Description",
    "item.property.label.quantity": "Quantity",
    "subItem.property.label.totalList": "List",
    "subItem.property.label.totalCost": "Cost",
    "subItem.property.label.totalNet": "Net",
    "lineItems.bom.label": "Bill of materials",
    "priceSummary.totalCost": "Total cost",
    "priceSummary.totalList": "Total list",
    "priceSummary.totalNet": "Total net",
    "dialog.requestQuote.title": "Send request",
    "select.topBottom.option.label.top": "List",
    "select.topBottom.option.label.bottom": "Cost+",
    "priceList.select.confirm.title": "Do you want to proceed?",
    "priceList.select.confirm.subtitle":
      "Changing the price list at this level will overwrite all price lists at lower levels.",
    "toast.error.unknown": "An error occurred",
    "toast.success.itemWasAddedToQuote": "Item was added to quote",
    "toast.success.groupCreated": "The group was created",
    "toast.success.groupWithItemsCreated":
      "The group was created and Items were added",
    "toast.success.itemWasAddedToCart": "Item was added to the cart",
    "form.field.label.customerNumber": "Customer Number",
    "form.field.label.companyName": "Company Name",
    "form.field.label.company": "Company",
    "form.field.label.name": "Name",
    "form.field.label.contactSalutation": "Salutation",
    "form.field.label.contactTitle": "Title",
    "form.field.label.contactFirstName": "Name",
    "form.field.label.contactLastName": "Last Name",
    "form.field.label.street": "Street",
    "form.field.label.streetNumber": "Number",
    "form.field.label.postalCode": "Postal Code",
    "form.field.label.town": "Town",
    "form.field.label.country": "Country",
    "form.field.label.emailAddress": "Email",
    "form.field.label.phoneNumber": "Phone",
    "form.field.label.mobileNumber": "Mobile",
    "form.field.label.companyId": "Company",
    "form.field.label.description": "Description",
    "form.field.error.email": "Email address is not valid",
    "quoteInfo.buttons.addNewCustomer": "Add new customer",
    "quoteInfo.buttons.addNewCompany": "Add new company",
    "quoteInfo.buttons.addNewSalesLocation": "Add new sales",
    "quoteInfo.buttons.assignSalesLocation": "Assign",
    "quoteInfo.buttons.assignCustomer": "Assign customer",
    "quoteInfo.buttons.save": "Assign customer",
    "quoteInfo.general.header": "General information",
    "quoteInfo.general.quoteId": "Quote id",
    "quoteInfo.general.quote.uniqueNumberString": "Quote number",
    "quoteInfo.general.opportunity.uniqueNumberString": "Opportunity number",
    "quoteInfo.general.currency": "Currency",
    "quoteInfo.general.createdByName": "Created by",
    "quoteInfo.general.quoteCreationDate": "Quote creation date",
    "quoteInfo.general.lastUpdatedByName": "Last updated by",
    "quoteInfo.general.lastUpdatedOn": "Last updated on",
    "quoteInfo.salesLocation.header": "Sales",
    "quoteInfo.customer.header": "Customer",
    "quoteInfo.customer.customerNumber": "Customer number",
    "quoteInfo.customer.companyName": "Company name",
    "quoteInfo.customer.contactSalutation": "Salutation",
    "quoteInfo.customer.contactFirstName": "First name",
    "quoteInfo.customer.contactLastName": "Last name",
    "quoteInfo.customer.contactTitle": "Title",
    "quoteInfo.customer.street": "Street",
    "quoteInfo.customer.streetNumber": "Street number",
    "quoteInfo.customer.postalCode": "Postal code",
    "quoteInfo.customer.town": "Town",
    "quoteInfo.customer.country": "Country",
    "quoteInfo.customer.emailAddress": "Email",
    "quoteInfo.customer.phoneNumber": "Phone number",
    "quoteInfo.customer.mobileNumber": "Mobile number",
    "dialog.createSalesLocation.title": "Create sales location",
    "dialog.createSalesLocation.subtitle": "Create a new sales location",
    "quoteInfo.customer.salesLocations.header": "Sales",
    "quoteInfo.customer.salesLocations.salesLocationName":
      "Sales locations name",
    "quoteInfo.customer.salesLocations.contactTitle": "Title",
    "quoteInfo.customer.salesLocations.contactSalutation": "Salutation",
    "quoteInfo.customer.salesLocations.contactFirstName": "First name",
    "quoteInfo.customer.salesLocations.contactLastName": "Last name",
    "quoteInfo.customer.salesLocations.street": "Street",
    "quoteInfo.customer.salesLocations.streetNumber": "Street number",
    "quoteInfo.customer.salesLocations.postalCode": "Postal code",
    "quoteInfo.customer.salesLocations.town": "Town",
    "quoteInfo.customer.salesLocations.country": "Country",
    "quoteInfo.customer.salesLocations.emailAddress": "Email",
    "quoteInfo.customer.salesLocations.phoneNumber": "Phone number",
    "quoteInfo.customer.salesLocations.mobileNumber": "Mobile number",
    "dialog.addCustomProduct.priceCost.value": "Value",
    "dialog.addCustomProduct.priceCost.validFrom": "Valid from",
    "dialog.addCustomProduct.priceCost.validTo": "Valid to",
    "dialog.addCustomProduct.price": "Price",
    "dialog.addCustomProduct.cost": "Cost",
    "productDetails.partId": "Article number",
    "productDetails.listPrice": "List price",
    "productDetails.cost": "Cost",
    "searchField.label": "Search",
    "SERVER_ERROR.DISCOUNT_EXCEEDS_LIMIT": "Discount exceeds limit",
    "SERVER_ERROR.PRODUCT_IS_IN_USE": "Product is in use and cannot be deleted",
    "filter.filterAttributeInput.label": "Attribute",
    "filter.filterOperatorInput.label": "Operator",
    "filter.filterValueInput.label": "Value",
    "filter.button.applyFilter": "Apply",
    "filter.button.clearAllFilter": "Clear all",
    "toast.error.filterAlreadyPresent": "Filter already present",
    "selectionBanner.text": "{{selectedProducts}} products selected",
    "selectionBanner.clearSelection.text": "clear selection",
    "cart.label.emptyCart": "Your cart is empty",
    "cart.button.addConfiguration": "Add configuration",
    "cart.button.addArticle": "Add article",
    "cart.button.saveShoppingCart": "Save shopping cart",
    "cart.button.printShoppingCart": "Print shopping cart",
    "cart.button.import": "Import",
    "cart.button.export": "Export",
    "cart.summary.subtotal.label": "Subtotal",
    "cart.summary.totalNet.label": "Total net",
    "cart.summary.button.requestQuote": "Request Quote",
    "cart.summary.button.proceedToCheckout": "Proceed to Checkout",
    "quotes.table.uniqueNumberString": "Number",
    "quotes.table.name": "Name",
    "quotes.table.lastUpdatedOn": "Last updated",
    "quotes.table.creationDate": "Creation date",
    "quotes.table.status": "Status",
    "quotes.table.toolbar.search": "Search",
    "infotext.userNotLoggedIn": "Not logged in",
    "buttons.save": "Salvar",
    "buttons.reset": "Reiniciar",
    "quotes.table.toolbar.filters.status": "Status",
    "iconButton.download": "Download",
    "iconButton.clone": "Duplicar",
    "iconButton.delete": "Excluir",
    "drawer.showBOM.title": "Bill of materials",
    "drawer.showSummary.title": "Resumo",
    "workflowSelect.title": "Please choose a Workflow",
    "workflowSelect.customer.title": "Customer",
    "workflowSelect.customer.subTitle":
      "A streamlined workflow for browsing and purchasing products.",
    "workflowSelect.sales.title": "Sales",
    "workflowSelect.sales.subTitle":
      "Configure, price and quote with an integrated catalog, tailored for sales persons.",
    "workflowSelect.projectList.title": "Project List",
    "workflowSelect.projectList.subTitle":
      "Manage articles and projects efficiently with a comprehensive list view.",
    "moveRowMenu.options.topPosition": "Top postion",
    "opportunities.quotesTable.header.name": "Name",
    "opportunities.quotesTable.header.description": "Description",
    "opportunities.quotesTable.header.customer": "Customer",
    "opportunities.quotesTable.header.quoteNumber": "Quote number",
    "opportunities.quotesTable.header.createdByName": "Created by",
    "opportunities.quotesTable.header.lastUpdatedByName": "Last updated by",
    "opportunities.quotesTable.header.lastUpdatedOn": "Last updated on",
    "opportunities.quotesTable.header.status": "Status",
    "outputOptionsSelection.checkbox.includeLongText.label":
      "Includes Long Text",
    "outputOptionsSelection.checkbox.includePartId.label":
      "Includes Part Number of Articles",
    "outputOptionsSelection.checkbox.includePrices.label": "Includes Prices",
    "outputOptionsSelection.checkbox.includeDiscounts.label":
      "Includes Discounts",
  },
  translation: { DATA_SHEET: "Ficha técnica" },
  WEG: {
    "appcalc.recommendation.flag": "Recomendação WEG",
    "btn.askForQuote": "Solicitar orçamento",
    "btn.import": "importar",
    "btn.importConfigId": "Importar ID GPS",
    "btn.loginToEasy": "Voltar ao EASY",
    "btn.sendRequest": "Enviar solicitação",
    "btn.setAdministrationArea": "Acessar",
    "button.send": "Enviar",
    "button.back": "Voltar",
    "button.upload": "Carregar",
    "buttons.addToQuote": "Adicionar à lista de itens",
    "buttons.backToCart": "Ir para a lista de projetos",
    "buttons.backToRoot": "Ir para a página inicial",
    "buttons.cancel": "Cancelar",
    "buttons.confirm": "Confirmar",
    "buttons.download": "Download",
    "buttons.ExitConfigurationButton": "Lista de projetos",
    "buttons.ExitWithoutSavingButton": "Sair",
    "buttons.header.returnToWEG": "Página inicial",
    "buttons.header.returnToWEG.url":
      "https://www.weg.net/catalog/weg/BR/pt/Redutores-e-Multiplicadores-de-Velocidade-/c/BR_GEARBOXES",
    "buttons.header.toProjectList": "Reiniciar configuração",
    "buttons.resetConfiguration": "Redefinir",
    "buttons.SaveAndExitConfigurationButton": "Salvar e sair",
    "buttons.saveAsTemplate": "Salvar modelo",
    "buttons.SaveConfigurationButton": "Salvar configuração",
    "buttons.AddToProjectList": "Salvar na lista de projetos",
    "buttons.select": "Selecionar",
    "buttons.showAllProjects": "Exibir todos os projetos",
    "cart.table.header.configurationId": "ID GPS",
    "cart.table.header.customerId": "TAG do cliente",
    "cart.table.header.item": "Item",
    "cart.table.header.notes": "Notas",
    "cart.table.header.quantity": "Quantidade",
    "cart.table.header.syncSelect": "Sincronizar",
    "cart.table.header.type": "Tipo",
    "cart.table.header.priceIndicator": "Indicador de preço",
    "cart.table.header.status": "Status",
    "cartViewHeader.button.title": "Nova configuração",
    "config.btn.searchProduct": "Buscar produto",
    "description.configurator.appCalc":
      "Dimensione o produto com os dados do seu equipamento",
    "description.configurator.productConfigurator":
      "Dimensione o produto com dados de acionamento",
    "dialog.addToQuote.title": "Por favor, selecione um item",
    "dialog.administrationArea.header": "Localização",
    "error.invalidGUID": "ID GPS inválido",
    "error.noPOSfound": "Erro na busca de contato. Contate o administrador",
    "header.cart.title": "Lista de projetos",
    "label.configId": "ID de configuração",
    "label.country": "País",
    "label.form.city": "Cidade",
    "label.form.company": "Empresa",
    "label.form.companyName": "Nome da Empresa",
    "label.form.country": "País",
    "label.form.email": "E-mail",
    "label.form.formCity": "Cidade",
    "label.form.formDistrict": "Bairro",
    "label.form.formPurchasePlace": "País",
    "label.form.formRegion": "Estado",
    "label.form.formUserComment": "Comentarios adicionales",
    "label.form.name": "Nome",
    "label.form.phone": "Telefone",
    "label.form.phoneNumber": "Telefone",
    "label.form.street": "Rua",
    "label.form.streetNr": "Nº",
    "label.form.surname": "Sobrenome",
    "label.form.userInquiry": "Qual a sua solicitação?",
    "label.form.zipCode": "CEP",
    "latestProjects.table.header.batch": "Comissão",
    "latestProjects.table.header.lastChange": "Última alteração",
    "latestProjects.table.header.orderNumber": "Número do pedido",
    "latestProjects.table.header.projectName": "Nome do projeto",
    "latestProjects.table.header.projectNumber": "Número do projeto",
    "latestProjects.table.title": "Projetos mais recentes",
    "message.confirmSendQuoteRequest":
      "Enviar esta solicitação irá finalizar o processo e excluir os itens da lista de projetos.",
    "message.errorSendQuoteRequest":
      "Infelizmente não foi possível concluir a solicitação. Por favor, tente novamente.",
    "message.successSendQuoteRequest":
      "Enviamos sua solicitação para nosso time de vendas e iremos retornar o mais breve possível.",
    "modal.ExitConfiguration.note":
      "Alteração não salvas serão perdidas. Continuar?",
    "modal.ExitConfiguration.title": "Ir para a lista de projetos",
    "preselector.page1.linkText": "Contate-nos",
    "preselector.subcaption.text":
      "Encontre o produto conforme sua necessidade.",
    "products.buttons.addToQuote": "Adicionar à lista de itens",
    "products.buttons.configure": "Configurar",
    "title.configurator.appCalc": "Cálculo de aplicação",
    "title.configurator.preselection": "Gear ProSelect",
    "title.configurator.productConfigurator": "Configurador de produto",
    "title.confirmSendQuoteRequest": "Solicitar cotação",
    "title.successSendQuoteRequest": "Obrigado pela sua solicitação!",
    "toast.JmpToEasy.timeout":
      "Tempo limite de conexão com o Easy esgotado. Tente novamente.",
    "tooltip.copyToClipboard": "Duplicar",
    "subconfigurationNavigation.previousItem": "Voltar",
    "subconfigurationNavigation.nextItem": "Avançar",
    "buttons.edit": "Editar",
    "response.WegStoreFinderError":
      "Código de status da API do Easy {{params}}",
    "response.Unauthorized": "ID de sessão não encontrado.",
    "response.NoQuoteFound":
      "Nenhuma cotação encontrada para esta sessão: {{params}}",
    "response.SomethingWentWrong": "Algo deu errado: {{params}}",
    "response.NoDownloadManual": "Nenhum manual de produto encontrado.",
    "response.WrongInputParameters":
      "Os seguintes parâmetros de entrada são necessários: {{params}}",
    noQuoteFound: "Nenhuma cotação encontrada para esta sessão: {{params}}",
    noConfigurationsFound: "Nenhuma configuração selecionada",
    noBaseConfigurableFound: "Nenhuma configuração base encontrada",
    noFromToCharacteristics:
      "Não foi encontrado características para os itens selecionados",
    "buttons.downloadUserManual": "Manual do produto",
    footerCopyright: "WEG | Gear ProSelect",
    ProjectListEmptyMsg: "não há projetos",
    "error.projectList.noItems": "não há projetos",
    "error.projectList.incompleteItems":
      "Alguns projetos ainda estão incompletos",
  },
};
